import { render, staticRenderFns } from "./allmarks.vue?vue&type=template&id=6709d03b&"
import script from "./allmarks.vue?vue&type=script&lang=js&"
export * from "./allmarks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports